export const WORK_NEWS_0407 = [
  {
    "id": "news-0407-work-01",
    "title": "【职等你来】全省绿色低碳城乡人才需求发布对接活动4月11日举办",
    "date": "2026-04-06",
    "displayDate": "2026年4月6日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_10_1.png",
    "blocks": [
      {
        "type": "paragraph",
        "text": "2026江苏绿色低碳建筑国际博览会将于4月9日至11日在南京国际博览中心举办。为进一步促进行业人才供需高效对接，4月11日将开展全省绿色低碳城乡人才需求发布对接活动。"
      },
      {
        "type": "heading3",
        "text": "时间地点"
      },
      {
        "type": "paragraph",
        "text": "时间：4月11日9:00-11:30"
      },
      {
        "type": "paragraph",
        "text": "地点：南京国际博览中心（江苏省南京市建邺区江东中路300号）5A登录厅"
      },
      {
        "type": "heading3",
        "text": "面对对象"
      },
      {
        "type": "paragraph",
        "text": "计算机、建筑工程、金融等多个专业方向的研究生、本科、专科等各学历层次人才。"
      },
      {
        "type": "image",
        "src": "0407_10_1.png",
        "alt": "【职等你来】全省绿色低碳城乡人才需求发布对接活动4月11日举办"
      },
      {
        "type": "paragraph",
        "text": "扫描上方二维码，获取详细岗位信息",
        "className": "venue-text"
      },
      {
        "type": "paragraph",
        "text": "本次活动汇聚近70家优质企业，提供千余个用人岗位，诚邀各界英才踊跃参与、筑梦绿建，共同搭建供需对接桥梁，为行业高质量发展注入强劲人才动能！"
      }
    ]
  },
  {
    "id": "news-0407-work-02",
    "title": "2026江苏绿色低碳建筑国际博览会第一批活动清单速览!",
    "date": "2026-03-28",
    "displayDate": "2026年3月28日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_0407-1.jpg",
    "blocks": [
      {
        "type": "image",
        "src": "0407_0407-1.jpg",
        "alt": "2026江苏绿色低碳建筑国际博览会第一批活动清单速览!",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "paragraph",
        "text": "2026江苏绿色低碳建筑国际博览会将于4月9日至11日在南京国际博览中心举办，届时将组织推介发布、技术交流、对接洽谈、公众互动等多元化活动（第一批活动清单见下图）。"
      },
      {
        "type": "image",
        "src": "0407_0407-2.jpg",
        "alt": "2026江苏绿色低碳建筑国际博览会第一批活动清单速览!",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "paragraph",
        "text": "*活动以现场为准，联系方式：51868252。"
      },
      {
        "type": "image",
        "src": "0407_0407-3.jpg",
        "alt": "2026江苏绿色低碳建筑国际博览会第一批活动清单速览!",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "paragraph",
        "text": "参观博览会请提前完成线上报名登记，入场需持身份证进行核验。"
      }
    ]
  },
  {
    "id": "news-0407-work-03",
    "title": "2026江苏绿色低碳建筑国际博览会活动介绍 ——“全流程水质管理及智慧实验室应用”技术交流议程速览",
    "date": "2026-03-30",
    "displayDate": "2026年3月30日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_5_1.png",
    "blocks": [
      {
        "type": "paragraph",
        "text": "2026江苏绿色低碳建筑国际博览会将于2026年4月9-11日在南京举办。为加强供水全流程水质保障，推动水务领域科技创新，江苏省城镇供水安全保障中心、江苏省城镇供水排水协会定于2026江苏绿色低碳建筑国际博览会期间，举行“全流程水质管理及智慧实验室应用”专题技术交流，现将有关事项通知如下。"
      },
      {
        "type": "paragraph",
        "text": "活动主题"
      },
      {
        "type": "paragraph",
        "text": "全流程水质管理及智慧实验室应用"
      },
      {
        "type": "paragraph",
        "text": "举办单位"
      },
      {
        "type": "paragraph",
        "text": "主办单位："
      },
      {
        "type": "paragraph",
        "text": "江苏省城镇供水安全保障中心、江苏省城镇供水排水协会"
      },
      {
        "type": "paragraph",
        "text": "承办单位："
      },
      {
        "type": "paragraph",
        "text": "江苏省城镇供水排水协会供水专业委员会"
      },
      {
        "type": "paragraph",
        "text": "协办单位："
      },
      {
        "type": "paragraph",
        "text": "南京水务集团有限公司、江苏城镇给排水监测有限公司"
      },
      {
        "type": "paragraph",
        "text": "时间与地点"
      },
      {
        "type": "paragraph",
        "text": "时间：2026年4月9日（星期四）至4月10日（星期五）"
      },
      {
        "type": "paragraph",
        "text": "地点：南京市国际博览会议中心403会议室（南京市建邺区双闸街道江东中路300号）"
      },
      {
        "type": "paragraph",
        "text": "参加人员"
      },
      {
        "type": "paragraph",
        "text": "各地城市供水管理事业单位相关负责同志、城镇公共供水企业水质及实验室分管负责同志、水质检测实验室负责人和技术骨干等。"
      },
      {
        "type": "paragraph",
        "text": "其他事项"
      },
      {
        "type": "paragraph",
        "text": "1.请参会人员于3月31日前将回执（详见通知附件2）发送至邮箱：jssgszx@126.com；"
      },
      {
        "type": "paragraph",
        "text": "2.联系人：省城镇供水安全保障中心，付晓瑞，025-51868310；省城镇供水排水协会，顾梁，15896247298。"
      },
      {
        "type": "image",
        "src": "0407_5_1.png",
        "alt": "2026江苏绿色低碳建筑国际博览会活动介绍 ——“全流程水质管理及智慧实验室应用”技术交流议程速览"
      },
      {
        "type": "image",
        "src": "0407_5_2.png",
        "alt": "2026江苏绿色低碳建筑国际博览会活动介绍 ——“全流程水质管理及智慧实验室应用”技术交流议程速览"
      },
      {
        "type": "image",
        "src": "0407_5_3.png",
        "alt": "2026江苏绿色低碳建筑国际博览会活动介绍 ——“全流程水质管理及智慧实验室应用”技术交流议程速览"
      },
      {
        "type": "image",
        "src": "0407_5_4.png",
        "alt": "2026江苏绿色低碳建筑国际博览会活动介绍 ——“全流程水质管理及智慧实验室应用”技术交流议程速览"
      },
      {
        "type": "image",
        "src": "0407_5_5.png",
        "alt": "2026江苏绿色低碳建筑国际博览会活动介绍 ——“全流程水质管理及智慧实验室应用”技术交流议程速览"
      },
      {
        "type": "image",
        "src": "0407_5_6.png",
        "alt": "2026江苏绿色低碳建筑国际博览会活动介绍 ——“全流程水质管理及智慧实验室应用”技术交流议程速览"
      },
      {
        "type": "image",
        "src": "0407_5_7.png",
        "alt": "2026江苏绿色低碳建筑国际博览会活动介绍 ——“全流程水质管理及智慧实验室应用”技术交流议程速览"
      }
    ]
  },
  {
    "id": "news-0407-work-04",
    "title": "倒计时2天！一文全览2026江苏绿色低碳建筑国际博览会交通、住宿、入场信息~",
    "date": "2026-04-07",
    "displayDate": "2026年4月7日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_12_1.jpg",
    "blocks": [
      {
        "type": "image",
        "src": "0407_12_1.jpg",
        "alt": "倒计时2天！一文全览2026江苏绿色低碳建筑国际博览会交通、住宿、入场信息~"
      },
      {
        "type": "image",
        "src": "0407_12_2.png",
        "alt": "倒计时2天！一文全览2026江苏绿色低碳建筑国际博览会交通、住宿、入场信息~"
      },
      {
        "type": "heading3",
        "text": "交通参考信息"
      },
      {
        "type": "image",
        "src": "0407_12_3.gif",
        "alt": "倒计时2天！一文全览2026江苏绿色低碳建筑国际博览会交通、住宿、入场信息~"
      },
      {
        "type": "image",
        "src": "0407_12_4.jpg",
        "alt": "倒计时2天！一文全览2026江苏绿色低碳建筑国际博览会交通、住宿、入场信息~"
      },
      {
        "type": "paragraph",
        "text": "机场线地铁：南京南站换乘地铁1号线到安德门换乘10号线到元通站下，4号出口出站。"
      },
      {
        "type": "paragraph",
        "text": "南京火车站：地铁1号线到新街口换乘2号线到元通站下，4号出口出站。"
      },
      {
        "type": "paragraph",
        "text": "南京南站:地铁1号线到安德门换乘10号线到元通站下，4号出口出站。"
      },
      {
        "type": "paragraph",
        "text": "自驾：导航至南京国际博览中心12号门，由P1停车场进入。"
      },
      {
        "type": "heading3",
        "text": "参观时间"
      },
      {
        "type": "paragraph",
        "text": "每日闭馆前30分钟停止登记入场"
      },
      {
        "type": "paragraph",
        "text": "04月09日（星期四）"
      },
      {
        "type": "paragraph",
        "text": "9:00-17:00"
      },
      {
        "type": "paragraph",
        "text": "04月10日（星期五）"
      },
      {
        "type": "paragraph",
        "text": "9:00-17:00"
      },
      {
        "type": "paragraph",
        "text": "04月11日（星期六）"
      },
      {
        "type": "paragraph",
        "text": "9:00-16:30"
      },
      {
        "type": "heading3",
        "text": "住宿参考信息"
      },
      {
        "type": "image",
        "src": "0407_12_5.png",
        "alt": "倒计时2天！一文全览2026江苏绿色低碳建筑国际博览会交通、住宿、入场信息~"
      }
    ]
  },
  {
    "id": "news-0407-work-05",
    "title": "倒计时3天 | 喜欢打卡互动的小伙伴们千万别错过！这儿有惊喜等你来~",
    "date": "2026-04-06",
    "displayDate": "2026年4月6日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_11_1.jpg",
    "blocks": [
      {
        "type": "image",
        "src": "0407_11_1.jpg",
        "alt": "倒计时3天 | 喜欢打卡互动的小伙伴们千万别错过！这儿有惊喜等你来~"
      },
      {
        "type": "paragraph",
        "text": "2026江苏绿色低碳建筑国际博览会",
        "className": "venue-text"
      },
      {
        "type": "paragraph",
        "text": "不仅是面向专业人士的交流平台",
        "className": "venue-text"
      },
      {
        "type": "paragraph",
        "text": "更是面向普通观众的“宝藏打卡地”",
        "className": "venue-text"
      },
      {
        "type": "paragraph",
        "text": "惊喜好礼拿不停",
        "className": "venue-text"
      },
      {
        "type": "paragraph",
        "text": "更有“苏超观赛资格”等着你~",
        "className": "venue-text"
      },
      {
        "type": "paragraph",
        "text": "那么……到底怎么逛才能收获感满满？",
        "className": "venue-text"
      },
      {
        "type": "paragraph",
        "text": "看这条，玩转博览会！",
        "className": "venue-text"
      },
      {
        "type": "image",
        "src": "0407_11_2.jpg",
        "alt": "倒计时3天 | 喜欢打卡互动的小伙伴们千万别错过！这儿有惊喜等你来~"
      }
    ]
  },
  {
    "id": "news-0407-work-06",
    "title": "逛展也能攒学时｜把课堂搬进建设科技一线",
    "date": "2026-04-04",
    "displayDate": "2026年4月4日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_9_1.jpg",
    "blocks": [
      {
        "type": "paragraph",
        "text": "2026年4月9日至11日，江苏绿色低碳建筑国际博览会将以“科技创新赋能城乡高质量发展”为主题在南京国际博览中心盛大启幕， 重点展示人工智能+住房城乡建设、高品质住宅、城市更新、宜居韧性智慧城市、智能建造、绿色低碳建筑等最新技术和产品；同期还将举办供需对接、推介发布、交流洽谈等多元化活动。"
      },
      {
        "type": "paragraph",
        "text": "根据专业技术人员继续教育相关规定，建设工程领域人才需定期完成学时更新。除线上课程、集中培训等传统学习方式外，本次博览会创新推出\"建设科技创新技术观摩实践活动\"——将课堂从课桌延伸至现场，在技术应用实践场景中开展沉浸式教学，学习成果可按规定计入继续教育学时。"
      },
      {
        "type": "heading3",
        "text": "时间地点"
      },
      {
        "type": "paragraph",
        "text": "时间： 2026年4月9-11日 9:00-17:00"
      },
      {
        "type": "paragraph",
        "text": "地点： 南京国际博览中心（建邺区江东中路300号，河西）4号馆、5号馆"
      },
      {
        "type": "heading3",
        "text": "面向对象"
      },
      {
        "type": "paragraph",
        "text": "1.本省建设工程专业技术人员。"
      },
      {
        "type": "paragraph",
        "text": "2.注册人员：包含一级建筑师、二级建筑师、一级建造师、二级建造师、一级造价工程师、二级造价工程师、监理工程师、一级结构工程师、二级结构工程师、注册土木工程师（岩土）、房地产估价师。"
      },
      {
        "type": "heading3",
        "text": "打卡指南"
      },
      {
        "type": "heading4",
        "text": "第1步"
      },
      {
        "type": "paragraph",
        "text": "填写信息"
      },
      {
        "type": "paragraph",
        "text": "在国际博览中心3B登录厅领取《学习记录手册》（又称《零碳护照》），并在个人信息登记页准确填写基本信息。"
      },
      {
        "type": "image",
        "src": "0407_9_1.jpg",
        "alt": "逛展也能攒学时｜把课堂搬进建设科技一线",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "第2步"
      },
      {
        "type": "paragraph",
        "text": "规划路线"
      },
      {
        "type": "paragraph",
        "text": "根据手册内地图合理规划参观学习路线。"
      },
      {
        "type": "heading4",
        "text": "第3步"
      },
      {
        "type": "paragraph",
        "text": "打卡"
      },
      {
        "type": "paragraph",
        "text": "现场开展技术观摩与实践互动，完成后工作人员将在手册加盖学习确认章。按手册要求集齐8枚印章即为有效打卡。"
      },
      {
        "type": "heading4",
        "text": "第4步"
      },
      {
        "type": "paragraph",
        "text": "核验登记"
      },
      {
        "type": "paragraph",
        "text": "学习完成后前往国际博览中心5号馆活动服务台，出示有效身份证件（身份证、电子身份证、驾驶证等），工作人员将完成学时核验登记。"
      },
      {
        "type": "heading4",
        "text": "第5步"
      },
      {
        "type": "paragraph",
        "text": "领取学时"
      },
      {
        "type": "paragraph",
        "text": "核验通过后，工作人员将现场打印继续教育学时证明（8个学时，且每人只能领取一次）。"
      },
      {
        "type": "heading3",
        "text": "重要提示"
      },
      {
        "type": "paragraph",
        "html": "<strong>1.人证一致：</strong>手册个人信息页须由本人填写，最终核验须出示与填录信息一致的有效身份证件。"
      },
      {
        "type": "paragraph",
        "html": "<strong>2.认证标准：</strong>必须按手册要求集齐8枚印章。"
      },
      {
        "type": "paragraph",
        "html": "<strong>3.信息准确：</strong>学时证明现场打印，一经发出无法修改，请确保登记信息准确无误。"
      },
      {
        "type": "paragraph",
        "html": "<strong>4.凭证保管：</strong>继续教育学时证明请妥善保管，作为继续教育完成的有效凭证。如凭证丢失，无法补办。"
      },
      {
        "type": "paragraph",
        "text": "参观博览会请提前完成线上报名登记，入场需持身份证进行核验。了解展会介绍、展商手册、活动指南等资讯请关注“江苏建设”“绿色城乡建设”公众号。"
      }
    ]
  },
  {
    "id": "news-0407-work-07",
    "title": "江苏绿色低碳建筑国际博览会第二批活动清单速览！",
    "date": "2026-03-28",
    "displayDate": "2026年3月28日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_2-1.jpg",
    "blocks": [
      {
        "type": "image",
        "src": "0407_2-1.jpg",
        "alt": "江苏绿色低碳建筑国际博览会第二批活动清单速览！",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "paragraph",
        "text": "2026江苏绿色低碳建筑国际博览会将于4月9日至11日在南京国际博览中心举办，届时将组织推介发布、技术交流、对接洽谈、公众互动等多元化活动（第二批活动清单见下图）。"
      },
      {
        "type": "image",
        "src": "0407_2-2.jpg",
        "alt": "江苏绿色低碳建筑国际博览会第二批活动清单速览！",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "image",
        "src": "0407_2-3.jpg",
        "alt": "江苏绿色低碳建筑国际博览会第二批活动清单速览！",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "paragraph",
        "text": "*活动以现场为准，联系方式：51868252。"
      },
      {
        "type": "image",
        "src": "0407_2-4.jpg",
        "alt": "江苏绿色低碳建筑国际博览会第二批活动清单速览！",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "paragraph",
        "text": "参观博览会请提前完成线上报名登记，入场需持身份证进行核验。"
      }
    ]
  },
  {
    "id": "news-0407-work-08",
    "title": "邀您共绘 | 江苏住建领域首个“产业+人才”图谱启动编制",
    "date": "2026-03-30",
    "displayDate": "2026年3月30日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_6_1.png",
    "blocks": [
      {
        "type": "paragraph",
        "text": "为贯彻落实全省住房城乡建设工作会议精神，全省住房城乡建设领域产业图谱和人才图谱研究编制工作全面启动。"
      },
      {
        "type": "paragraph",
        "text": "编研两项图谱既是对已经发布的江苏省住房城乡建设领域技术图谱的纵深延展，也是一体推进全省住房城乡建设领域技术、产业、人才发展的重要举措；通过构建覆盖全产业链、全生命周期、全要素协同的三谱融合体系，将为住房城乡建设领域产业强链补链延链、人才精准引育提供科学依据、“靶向”支撑，促进产业科技创新，为住房城乡建设高质量发展持续注入内生动力。"
      },
      {
        "type": "paragraph",
        "text": "图谱编制组将在梳理全省住建领域产业、人才发展现状的基础上，按照“系统性与前瞻性相统一、科学性与实用性相统一、时效性与动态性相统一”的原则，系统构建住建领域“1+1+N+X”三谱体系，公开发布重点技术全景图、产业链全景图、应用场景产业支撑图、细分领域关键人才供需图等研究成果，清晰呈现产业链上下游协同关系、应用场景适配度、人才支撑强度等关键要素。"
      },
      {
        "type": "paragraph",
        "text": "编制产业图谱与人才图谱需要汇聚行业各方的智慧与力量，欢迎全省住房城乡建设领域相关行业协会学会与企业参与进来，切实提升图谱服务政府决策、指导地方实践、支撑行业发展的效能。"
      },
      {
        "type": "image",
        "src": "0407_6_1.png",
        "alt": "邀您共绘 | 江苏住建领域首个“产业+人才”图谱启动编制",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "image",
        "src": "0407_6_2.png",
        "alt": "邀您共绘 | 江苏住建领域首个“产业+人才”图谱启动编制",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "image",
        "src": "0407_6_3.png",
        "alt": "邀您共绘 | 江苏住建领域首个“产业+人才”图谱启动编制",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "paragraph",
        "text": "联系人：赵安安"
      },
      {
        "type": "paragraph",
        "text": "联系方式：025-51868150、18012927323"
      },
      {
        "type": "paragraph",
        "text": "邮箱：1192375531@qq.com"
      }
    ]
  },
  {
    "id": "news-0407-work-09",
    "title": "木构未来，无锡城建描绘城市新图景",
    "date": "2026-04-07",
    "displayDate": "2026年4月7日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": null,
    "blocks": [
      {
        "type": "paragraph",
        "text": "由省住房城乡建设厅主办的2026江苏绿色低碳建筑国际博览会（以下简称“博览会”），将于4月9日至11日在南京国际博览中心举办。博览会自2023年已成功举办两次，促成融资合作意向金额约170亿元人民币，成为服务行业创新发展的“四链融合”平台。2026博览会以“科技创新赋能城乡高质量发展”为主题，展示规模约2.4万平方米，共有300余家国内外知名企业和机构参展，重点展示人工智能+住房城乡建设、好房子建设、城市更新、城市治理、智能建造、绿色低碳发展等最新技术和产品。荔枝新闻推出《科技创新赋能城乡高质量发展》系列报道，围绕人工智能+住房城乡建设、“好房子”建设等百姓关注议题，走进参展企业，展现“十五五”规划开局之年，房地产业、建筑业的转型升级探索。"
      },
      {
        "type": "paragraph",
        "text": "城市是推动高质量发展、创造高品质生活、全面建设社会主义现代化国家的重要载体。当前，我国城市发展从大规模增量建设转向存量提质改造和增量结构调整并重，进入了城市更新的重要时期。"
      },
      {
        "type": "paragraph",
        "text": "经过五载蓄势发展，无锡城建发展集团已经成长为集投资、建设、管理、运营为一体的综合服务商，在城市更新系统工作中取得了一系列扎实成效。上届博览会中，其带来的现代木结构建筑创新成果闪耀全场，分体式可移动智能木屋、智慧生态舱等一系列新技术、新成果展现出现代木结构绿色、智能、安全、舒适的建筑特性。“博览会不仅给了我们展示现代木结构的机会，而且会后多个单位来和我们沟通交流并提出合作意愿。”该集团副总裁徐劲对在上届博览会中取得的成果高度评价。"
      },
      {
        "type": "paragraph",
        "text": "本次博览会，无锡城建将继续带来现代木结构产业的前沿分享，并系统展示借力现代木结构的城市更新工作创新突破与实践成果。紧扣城市更新核心战略，无锡城建打造了梁溪河十里画廊、无锡古运河东门片区等一批绿意盎然的标杆示范项目。其中，古运河东门片区贯彻“站城融合”理念，重塑江南“水客厅”，2.4公里滨水空间景观焕新，524户老旧小区居民居住环境质变，老城宜居底色愈发鲜明。该项目被列为全国5个老旧火车站及周边街区统筹实施更新改造试点项目之一。"
      },
      {
        "type": "paragraph",
        "text": "在城市更新系统工程上，无锡城建正从产融服务、物业运营等多维度全领域统筹布局，保障更新工作的高标准落地和高质量推进。其自主研发的智慧停车“一张网”平台积极推动“先离后付”便捷缴费模式，为城市停车治理构建“一网统管”格局，以数字技术破解城市停车难题。目前，无锡全市实现公共停车场静态泊位数据100%接入，已有超1000个停车场实现“先离场后付费”。"
      },
      {
        "type": "paragraph",
        "text": "集团副总裁徐劲进一步介绍,集团正围绕城市建设主业、产业创新发展、民生运营服务三重维度协同发力，力争在城市更新的系统工作中实现整体能力与水平的持续提升，筑造绿色低碳的美好城市未来。"
      },
      {
        "type": "paragraph",
        "text": "来源：荔枝新闻"
      }
    ]
  },
  {
    "id": "news-0407-work-11",
    "title": "通力再耀江苏绿色低碳建筑国际博览会 以绿色更新筑就城市未来",
    "date": "2026-04-04",
    "displayDate": "2026年4月4日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": null,
    "blocks": [
      {
        "type": "paragraph",
        "text": "由省住房城乡建设厅主办的2026江苏绿色低碳建筑国际博览会（以下简称“博览会”），将于4月9日至11日在南京国际博览中心举办。博览会自2023年已成功举办两次，促成融资合作意向金额约170亿元人民币，成为服务行业创新发展的“四链融合”平台。2026博览会以“科技创新赋能城乡高质量发展”为主题，展示规模约2.4万平方米，共有300余家国内外知名企业和机构参展，重点展示人工智能+住房城乡建设、好房子建设、城市更新、城市治理、智能建造、绿色低碳发展等最新技术和产品。荔枝新闻推出《科技创新赋能城乡高质量发展》系列报道，围绕人工智能+住房城乡建设、“好房子”建设等百姓关注议题，走进参展企业，展现“十五五”规划开局之年，房地产业、建筑业的转型升级探索。 来自芬兰的全球电梯领导者之一通力，已在中国内地深耕30年，与城市发展同频共振。布局起点始于苏州昆山，如今的通力昆山工业园已成为其全球最大生产基地与海外最大研发中心。"
      },
      {
        "type": "paragraph",
        "text": "当前，中国已全面进入城市更新新阶段，电梯市场也由高速增长的“增量时代”转向以更新改造、服务升级和智能化为主导的“存量时代”，老旧电梯安全与节能升级需求愈发紧迫。为此，通力推出多场景电梯更新改造方案，经TÜV权威测试，单台改造电梯年节电约3600度，可为物业与业主节约电费近1900元，让绿色效益真正惠及民生，积极助力“城市焕新”。"
      },
      {
        "type": "paragraph",
        "text": "在2026年1月26日芬兰总理奥尔波与中国商务部部长王文涛及芬兰工商界代表座谈中，王文涛特别提及：在去年江苏昆山老旧电梯更新项目中，通力一举中标2106台，占招标总量的96%，以亮眼实绩彰显了其在电梯更新改造领域的领先实力。"
      },
      {
        "type": "paragraph",
        "text": "在中国发展高层论坛2026年年会上，通力集团总裁兼首席执行官菲利普・德龙在接受人民网采访时表示，中国“十五五”规划纲要为企业未来发展指出了更为清晰的方向。持续推进的城市更新与数字化转型，正是通力的战略契合点。通力将继续加大在华投资，深度参与国家高质量发展进程。"
      },
      {
        "type": "paragraph",
        "text": "作为博览会的“老朋友”，通力将第二次在博览会亮相。重点围绕城市更新、老旧电梯改造、绿色低碳展示安全、绿色、智能一体化垂直交通方案，精准对接电梯更新、碳足迹管理等政策导向，为城市焕新提供持续动力。"
      },
      {
        "type": "paragraph",
        "text": "通力大中华区更新改造业务高级副总裁周芳表示：“博览会是深化合作的好平台。”2025年首展即获得市场与政府高度认可，今年通力进一步扩容升级，呈现多场景定制化更新方案。期待与更多深耕可持续发展、践行绿色节能环保理念的企业、政府部门及行业机构深化交流、携手合作。 来源：荔枝新闻"
      }
    ]
  },
  {
    "id": "news-0407-work-12",
    "title": "用造地标的精度盖住宅 中亿丰以硬科技 “筑” 守好房",
    "date": "2026-04-05",
    "displayDate": "2026年4月5日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": null,
    "blocks": [
      {
        "type": "paragraph",
        "text": "由省住房城乡建设厅主办的2026江苏绿色低碳建筑国际博览会（以下简称“博览会”），将于4月9日至11日在南京国际博览中心举办。博览会自2023年已成功举办两次，促成融资合作意向金额约170亿元人民币，成为服务行业创新发展的“四链融合”平台。2026博览会以“科技创新赋能城乡高质量发展”为主题，展示规模约2.4万平方米，共有300余家国内外知名企业和机构参展，重点展示人工智能+住房城乡建设、好房子建设、城市更新、城市治理、智能建造、绿色低碳发展等最新技术和产品。荔枝新闻推出《科技创新赋能城乡高质量发展》系列报道，围绕人工智能+住房城乡建设、“好房子”建设等百姓关注议题，走进参展企业，展现“十五五”规划开局之年，房地产业、建筑业的转型升级探索。"
      },
      {
        "type": "paragraph",
        "text": "“有序推动安全舒适绿色智慧的“好房子”建设，实施房屋品质提升工程和物业服务质量提升行动。”今年，“好房子”建设被再次写入全国两会政府工作报告，成为房地产高质量发展的核心抓手。"
      },
      {
        "type": "paragraph",
        "text": "在“好房子”建设中，江苏始终坚持规划布局与公共设施、环境营造协同发力，以科技创新提升民生温度。连续多年参加江苏绿色低碳建筑国际博览会（以下简称“博览会”）的中亿丰控股集团有限公司（以下简称“中亿丰”）正在以持续的研发投入，构建起绿色低碳、智能制造、智能建造三大新质生产力。本届博览会上，中亿丰将集中展示如何用智能制造手段助力“好房子”建设。"
      },
      {
        "type": "paragraph",
        "text": "作为苏州市“两智一全”（智能建造+智慧品质+全生命周期）试点项目，中亿丰建设在苏州北打造的忆丰园全面集成了企业在智能建造、绿色建材、智慧运维等领域的最新成果。项目以宋氏园林美学为设计灵感，打造超低能耗改善型住宅，采用了宋式铝合金幕墙、节能推拉气密门、断桥隔热静音窗、太阳能光伏系统等新型材料。外墙以平均传热系数低于 0.4 W/(㎡·K)的标准进行设计，住宅内设热回收装置，热回收效率达75%以上。“让房子既低碳环保，又能实现高品质居住体验，做到环保与舒适的双赢。”中亿丰物产集团策划经理昝亚萍介绍。"
      },
      {
        "type": "paragraph",
        "text": "智慧建造的背后离不开“指挥中枢”的统一调控。由中亿丰自主研发的国家级工业互联网平台——DTCLOUD亿智云，以“BIM+AIoT 数字孪生”为技术底座，打通了设计、生产、施工、运维全产业链关键环节，能够自动识别施工违规情况，对质量安全隐患实现秒级预警，同时智能施工升降机、搬运机器人等智能装备无缝接入亿智云平台，使得建筑机器人能够自主搭乘升降机到精确平层进行施工作业，破解传统施工升降机效率低、安全风险高的痛点，优化建筑工期，让建造过程更可控、更高效。“用数字技术与智能装备，建设更安全、更绿色、更宜居的‘好房子’是我们一以贯之的目标。”中亿丰数字科技集团总经理汪丛军介绍，以自主研发的亿智云工业互联网平台、建筑机器人集群、超低能耗住宅技术为核心支撑，搭建起覆盖设计、施工、运维全生命周期的绿色低碳建造体系，中亿丰以“软件+硬件”的融合创新模式，正在把“好房子”的建造标准落到每一道工序、每一个场景。"
      },
      {
        "type": "paragraph",
        "text": "从忆丰园的高品质绿色节能型未来住宅，到施工现场的机器人集群与数字大脑调度；从超低能耗技术的落地，到全生命周期智慧运维的搭建，中亿丰以74年建筑产业积淀为底，以新质生产力为基准点，将安全、绿色、智能、宜居的理念贯穿房屋建造全过程。在汪丛军看来，博览会已经成为江苏乃至全国建筑企业集中展示新技术、新产品和新业态、新模式的品牌窗口，过去三年，企业通过博览会收获了众多合作成果，今年他们也期待着继续与行业伙伴携手，为江苏乃至全国房地产高质量发展与智慧城乡建设注入持久动能。"
      },
      {
        "type": "paragraph",
        "text": "来源：荔枝新闻"
      }
    ]
  }
];

export const SPOTLIGHT_NEWS_0407 = [
  {
    "id": "news-0407-spot-01",
    "title": "2026江苏绿色低碳建筑国际博览会展商|华设设计集团",
    "date": "2026-03-29",
    "displayDate": "2026年3月29日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_640.png",
    "blocks": [
      {
        "type": "image",
        "src": "0407_3_1.png",
        "alt": "2026江苏绿色低碳建筑国际博览会展商|华设设计集团",
        "wrapperClassName": "zsfc_logo"
      },
      {
        "type": "paragraph",
        "text": "聚势两届，载誉前行！ 由江苏省住房和城乡建设厅主办的江苏绿色低碳建筑国际博览会（以下简称“博览会”），已成功举办两届。从2023年“名企汇聚、成果领先”的首秀惊艳，到2025年“聚焦前沿科技、聚力供需对接、聚合金融资源、聚集人才优势”的全面跃升，博览会持续以建设科技创新为核心，展现行业绿色低碳转型的生动实践，累计吸引200余家中外知名企业和机构参展，近3万人次专业客群到会交流，促成百亿元融资意向签约，成为推动住房城乡建设领域科技创新和产业创新融合发展的综合性平台。"
      },
      {
        "type": "paragraph",
        "text": "2026年4月9日至11日，第三届博览会将以“科技创新赋能城乡高质量发展”为主题在南京盛大启幕， 重点展示人工智能+住房城乡建设、高品质住宅、城市更新、宜居韧性智慧城市、智能建造、绿色低碳建筑等最新技术和产品；同期还将举办人才招聘、推介发布、交流洽谈、培训宣贯、公益科普等多元化活动。多家世界500强、行业领军以及专精特新企业已提前锁定展位。"
      },
      {
        "type": "paragraph",
        "text": "即日起，正式推出“展商风采”栏目，提前揭秘创新技术、明星产品和行业标杆，搭建供需精准对接的桥梁，诚邀各界共同见证科技创新赋能城乡未来！"
      },
      {
        "type": "heading3",
        "text": "展商简介"
      },
      {
        "type": "paragraph",
        "text": "华设设计集团(以下简称\"华设集团\")创立于1960年，前身为江苏省交通规划设计院，深耕交通、城乡两大基础设施领域，是中国领先的全过程咨询技术服务商。华设集团在全球拥有6000多名员工，综合实力位列\"全国勘察设计行业企业勘察设计收入前100名\"第5位、ENR\"全球工程设计公司150强\"第49位，拥有咨询综甲、勘察综甲、设计综甲和城乡规划甲级（\"三综一甲\"）行业顶级从业资质，先后荣获590多项国家及省部级奖项，以及国际桥梁大会亚瑟·海顿奖、国际咨询工程师联合会百年工程项目奖等十多项国际大奖。"
      },
      {
        "type": "heading3",
        "text": "展品简介"
      },
      {
        "type": "heading4",
        "text": "01城市更新"
      },
      {
        "type": "paragraph",
        "text": "以前期规划为引领，以老城综合开发、老旧小区改造、街区微更新、环境综合整治、商业消费为核心，以工业遗产、古建街区、商业楼宇提升改造为衍生，打造多专业融合、全产业链的城市更新“华设模式”，加快推动从城市设计者向城市综合运营商的角色转变。"
      },
      {
        "type": "heading4",
        "text": "02智慧化垂直起降场（低空）"
      },
      {
        "type": "paragraph",
        "text": "智慧化垂直起降场系统解决方案采用模块化设计，全面覆盖九大垂直起降场应用场景，为不同场景定制化适配技术与支持系统，涵盖了从技术解析到系统管理，再到服务响应网络的全链条布局可适配多元场景需求：文旅景区实现低空游览接驳，商务区构建空中通勤走廊，医疗救援开辟快速生命通道，水域场景支持两栖起降，工业园区满足物资运输及应急响应，交通枢纽打造立体化接驳节点，机库集成式设计实现驻停检修一体化，高速公路服务区布局应急救援点，维修基地配备全流程保障设施。"
      },
      {
        "type": "image",
        "src": "0407_3_2.png",
        "alt": "华设设计集团",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "03数字建设管理平台"
      },
      {
        "type": "paragraph",
        "text": "面向智慧城市与数字城市建设的宏大需求，数字建设管理平台专为城市级重大交通基础设施项目量身打造，是统筹工程建设全生命周期的核心数字中枢。平台打破传统单一项目的管理孤岛，针对城市轨道交通、快速路网、大型枢纽等城市级复杂工程，实现了业主、设计、施工、监理等多方参建单位的全域协同与高效办公。"
      },
      {
        "type": "image",
        "src": "0407_3_3.png",
        "alt": "华设设计集团",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "04韧性安全城市"
      },
      {
        "type": "paragraph",
        "text": "华设集团打造的城市安全韧性云，以CIM+物联+数据+AI算法仓为核心底座，融合多感知手段与专业模型，构建“感知-分析-决策-执行-迭代”闭环。实现城市安全风险全感知、跨部门跨行业协同联动、耦合模型强分析能力，推动治理从被动响应到主动预测、散点治理到体系治理、经验判断到数据决策的转变，赋能内涝、建筑、桥隧等多场景城市安全韧性建设，打造城市智能安全综合体。"
      },
      {
        "type": "heading3",
        "text": "目标客户"
      },
      {
        "type": "paragraph",
        "text": "诚邀各级政府相关主管部门、各地市城建平台公司等莅临参观，等如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。"
      }
    ]
  },
  {
    "id": "news-0407-spot-02",
    "title": "2026江苏绿色低碳建筑国际博览会展商|江苏云天精筑环境科技有限公司",
    "date": "2026-03-31",
    "displayDate": "2026年3月31日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_640.png",
    "blocks": [
      {
        "type": "image",
        "src": "0407_7_1.png",
        "alt": "2026江苏绿色低碳建筑国际博览会展商|江苏云天精筑环境科技有限公司",
        "wrapperClassName": "zsfc_logo"
      },
      {
        "type": "paragraph",
        "text": "聚势两届，载誉前行！ 由江苏省住房和城乡建设厅主办的江苏绿色低碳建筑国际博览会（以下简称“博览会”），已成功举办两届。从2023年“名企汇聚、成果领先”的首秀惊艳，到2025年“聚焦前沿科技、聚力供需对接、聚合金融资源、聚集人才优势”的全面跃升，博览会持续以建设科技创新为核心，展现行业绿色低碳转型的生动实践，累计吸引200余家中外知名企业和机构参展，近3万人次专业客群到会交流，促成百亿元融资意向签约，成为推动住房城乡建设领域科技创新和产业创新融合发展的综合性平台。"
      },
      {
        "type": "paragraph",
        "text": "2026年4月9日至11日，第三届博览会将以“科技创新赋能城乡高质量发展”为主题在南京盛大启幕， 重点展示人工智能+住房城乡建设、高品质住宅、城市更新、宜居韧性智慧城市、智能建造、绿色低碳建筑等最新技术和产品；同期还将举办人才招聘、推介发布、交流洽谈、培训宣贯、公益科普等多元化活动。多家世界500强、行业领军以及专精特新企业已提前锁定展位。"
      },
      {
        "type": "paragraph",
        "text": "即日起，正式推出“展商风采”栏目，提前揭秘创新技术、明星产品和行业标杆，搭建供需精准对接的桥梁，诚邀各界共同见证科技创新赋能城乡未来！"
      },
      {
        "type": "heading3",
        "text": "展商简介"
      },
      {
        "type": "paragraph",
        "text": "江苏云天精筑环境科技有限公司成立于2014年，是餐饮油烟治理、空气净化与消毒领域的一站式服务商。公司以美国PDMA、PMI体系为支撑，构建全生命周期项目管理体系。公司运营中心位于南京，在常州建有8000余平米研发制造中心，拥有国家级发明专利25项、实用新型专利34项，通过ISO9001、CCEP、CE等多项认证，具备建筑机电安装乙级资质与安全生产许可证，以高性价比产品与贴心服务守护品质。"
      },
      {
        "type": "heading3",
        "text": "展品简介"
      },
      {
        "type": "heading4",
        "text": "01移动式除霾设备"
      },
      {
        "type": "paragraph",
        "text": "由初效净化、高效 HEPA 净化、微静电净化、臭氧消解净化、VOCs净化五个功能段组成，针对悬浮颗粒物和臭氧等污染物逐级净化协同治理，采用外滤式多面进风与后倾式高压引风工艺，小时处理量达60000m³，可实时开展污染源在线监测，适用于建筑工地扬尘治理，人员密集场所、工业园区、局部重污染区域等场景，为空气治理提供精准管控与高效净化保障。"
      },
      {
        "type": "image",
        "src": "0407_7_2.png",
        "alt": "江苏云天精筑环境科技有限公司",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "02立式住宅油烟净化一体机"
      },
      {
        "type": "paragraph",
        "text": "立式住宅油烟净化一体机是专为家庭厨房油烟净化设计的设备，通过高效空气净化技术去除油烟有害物质，保护家人健康并减少环境污染。针对住宅居民楼定制，采用二次净化处理烟道油烟，确保排放达标。设备安装于住宅顶楼烟井口上方，集中收集下方居民油烟并净化，采用底部进风、顶部四面出风设计，背面底部收集废油，实现高效净化与环保处理。"
      },
      {
        "type": "image",
        "src": "0407_7_3.png",
        "alt": "江苏云天精筑环境科技有限公司",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading3",
        "text": "目标客户"
      },
      {
        "type": "paragraph",
        "text": "诚邀房地产开发商、物业公司、老旧小区改造单位、工业园区企业、局部重污染区域运营方等莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。"
      }
    ]
  },
  {
    "id": "news-0407-spot-03",
    "title": "2026江苏绿色低碳建筑国际博览会展商|苏州城投能碳科技发展有限公司",
    "date": "2026-03-29",
    "displayDate": "2026年3月29日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_640.png",
    "blocks": [
      {
        "type": "image",
        "src": "0407_4_1.png",
        "alt": "2026江苏绿色低碳建筑国际博览会展商|苏州城投能碳科技发展有限公司",
        "wrapperClassName": "zsfc_logo"
      },
      {
        "type": "paragraph",
        "text": "聚势两届，载誉前行！ 由江苏省住房和城乡建设厅主办的江苏绿色低碳建筑国际博览会（以下简称“博览会”），已成功举办两届。从2023年“名企汇聚、成果领先”的首秀惊艳，到2025年“聚焦前沿科技、聚力供需对接、聚合金融资源、聚集人才优势”的全面跃升，博览会持续以建设科技创新为核心，展现行业绿色低碳转型的生动实践，累计吸引200余家中外知名企业和机构参展，近3万人次专业客群到会交流，促成百亿元融资意向签约，成为推动住房城乡建设领域科技创新和产业创新融合发展的综合性平台。"
      },
      {
        "type": "paragraph",
        "text": "2026年4月9日至11日，第三届博览会将以“科技创新赋能城乡高质量发展”为主题在南京盛大启幕， 重点展示人工智能+住房城乡建设、高品质住宅、城市更新、宜居韧性智慧城市、智能建造、绿色低碳建筑等最新技术和产品；同期还将举办人才招聘、推介发布、交流洽谈、培训宣贯、公益科普等多元化活动。多家世界500强、行业领军以及专精特新企业已提前锁定展位。"
      },
      {
        "type": "paragraph",
        "text": "即日起，正式推出“展商风采”栏目，提前揭秘创新技术、明星产品和行业标杆，搭建供需精准对接的桥梁，诚邀各界共同见证科技创新赋能城乡未来！"
      },
      {
        "type": "heading3",
        "text": "展商简介"
      },
      {
        "type": "paragraph",
        "text": "苏州城投能碳科技发展有限公司是苏州城投集团下属企业，聚焦新能源开发与“双碳”服务，以“投资-运营-数字化赋能”模式，开展综合能源站、储能、售电及能源托管业务。公司自主研发AI+智控平台，构建产业园EaaS服务及6C碳管理体系，开展碳咨询、ESG等低碳业务。相关成果获1项发明、1项实用新型专利及8件软著，助力新索工坊·独墅湖产业园通过碳中和核查，“绿色建筑节能降耗AI动态优化模型”荣获数字中国创新大赛奖项。"
      },
      {
        "type": "heading3",
        "text": "展品简介"
      },
      {
        "type": "heading4",
        "text": "01分布式光伏应用案例"
      },
      {
        "type": "paragraph",
        "text": "生物医药产业园七期位于苏州独墅湖开放创新协同发展示范区“协同发展核心区”中的“高端创新产业集聚区”内。主要功能为研发、生物医药、医疗器械及配套。具有集“生产”、“生活”和“生态”于一体的产业环境。目前能碳公司投资建设的光伏一期已建成面积3300㎡，装机总功率超 700kWp，二期在建1400kWp。采用“自发自用，余电上网”模式，有效提升园区绿电使用率。"
      },
      {
        "type": "image",
        "src": "0407_4_2.jpg",
        "alt": "苏州城投能碳科技发展有限公司",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "02综合能源站应用案例"
      },
      {
        "type": "paragraph",
        "text": "中欧智造产业园项目位于苏州市相城中心城区，总占地面积12.5万平方米，总规划面积20万平方米。重点布局高端智能制造、新一代信息技术、新能源等主导产业，为国内外龙头高端装备制造企业打造全方位配套平台，是长三角地区绿色低碳智慧园区、中外合作典范产业园。苏州城投能碳科技发展有限公司投资建设运维的中欧智造产业园能源站于2025年成功投运，首期供冷能力4.48MW、供热3.02MW，服务园区办公面积2.59万㎡，全年累计供应冷热能量达25.48万kWh，已安全运行2880小时。"
      },
      {
        "type": "image",
        "src": "0407_4_4.jpg",
        "alt": "苏州城投能碳科技发展有限公司",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "03节能改造项目案例"
      },
      {
        "type": "image",
        "src": "0407_4_4.jpg",
        "alt": "苏州城投能碳科技发展有限公司",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "04数字化建设"
      },
      {
        "type": "paragraph",
        "text": "苏州城投能碳科技发展有限公司启动了以“人工智能+”为底座支撑的绿色建筑节能降耗AI动态优化模型开发，通过模型算法优化暖通系统运行效率，提升用户体验、提高运行质量，实现能耗与舒适度的智能平衡，最终达到节能减排和降本增效的目标。该模型成功获评“2025数字中国创新大赛数字城市赛道‘数字城市百景奖’”，并入选苏州市人工智能应用场景案例清单。"
      },
      {
        "type": "heading3",
        "text": "目标客户"
      },
      {
        "type": "paragraph",
        "text": "诚邀各类产业园区、商业综合体及公共机构等莅临参观，如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。"
      }
    ]
  },
  {
    "id": "news-0407-spot-04",
    "title": "2026江苏绿色低碳低碳建筑国际博览会|南京组团展",
    "date": "2026-03-31",
    "displayDate": "2026年3月31日",
    "wrapperClassName": "style-01-page",
    "contentClassName": "zsml_wap",
    "cover": "0407_640.png",
    "blocks": [
      {
        "type": "paragraph",
        "text": "2026年4月9日至11日，江苏绿色低碳建筑国际博览会将以“科技创新赋能城乡高质量发展”为主题在南京国际博览中心盛大启幕， 重点展示人工智能+住房城乡建设、高品质住宅、城市更新、宜居韧性智慧城市、智能建造、绿色低碳建筑等最新技术和产品；同期还将举办人才招聘、推介发布、交流洽谈、培训宣贯、公益科普等多元化活动。"
      },
      {
        "type": "paragraph",
        "text": "即日起，我们将推出“专题展区”栏目，全面展示创新成果与核心技术亮点，系列专题报道即将陆续推出。"
      },
      {
        "type": "paragraph",
        "text": "南京市将以“智慧筑宁，绿动未来”为主题，围绕“绿色建筑、韧性城市、城市更新、智能建造”等内容，结合南京市城建集团等五家单位的工作成效及其他参展企业的特点亮点工作，涵盖建材、建造、更新等领域，以成果展示、技术交流、场景体验为载体，兼顾城市形象和企业品牌，系统展示南京城建领域绿色低碳技术成果应用。"
      },
      {
        "type": "heading3",
        "text": "展区内容"
      },
      {
        "type": "heading4",
        "text": "01饱和潜水实验仓模型"
      },
      {
        "type": "paragraph",
        "text": "结构和原理类似空间站，其技术核心是将作业人员预先集中到地面核心仓，通过在仓内呼吸氦氮氧混合气体，适应高压环境，时长可达28天，作业时将核心舱运输至盾构机与人仓对接，进入盾构机刀盘前端作业，极大提高施工效率。"
      },
      {
        "type": "image",
        "src": "0407_8_1.png",
        "alt": "2026江苏绿色低碳低碳建筑国际博览会|南京组团展",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "02中铁十四局盾构刀盘换刀机器人"
      },
      {
        "type": "paragraph",
        "text": "可实现在带压进仓作业环境下精准抓取 and 完成滚刀更换所需要的各种动作，解决了人工换刀难度大、风险高、效率低的难题，换刀时间缩短至原来的三分之一。"
      },
      {
        "type": "image",
        "src": "0407_8_2.png",
        "alt": "2026江苏绿色低碳低碳建筑国际博览会|南京组团展",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "03中铁十四局盾构刀盘焊接机器人"
      },
      {
        "type": "paragraph",
        "text": "传统刀盘焊接需要10名以上高级焊工，用时2个月，且质量缺陷多，返工率高、施工效率低.智能焊接机器人基于“智能识别+智能控制”技术，可有效减少高级焊工6人，提升工效40%，焊接一次合格率达到98%以上。"
      },
      {
        "type": "image",
        "src": "0407_8_3.png",
        "alt": "2026江苏绿色低碳低碳建筑国际博览会|南京组团展",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "04 3D打印设备"
      },
      {
        "type": "paragraph",
        "text": "3D打印在异形构件制造方面具有显著优势.它通过数字化建模 and 逐层打印，能够轻松实现传统工艺难以完成的曲线、曲面 and 镂空等复杂几何造型 ，实现形式、结构 with 功能的有机统一.这种技术不仅能提高施工效率 and 精度，还能显著降低人工 and 材料成本.相比传统工艺，3D打印可节约建筑材料30%-60%，节约人工50%-80%，施工周期缩短50%-70%。"
      },
      {
        "type": "image",
        "src": "0407_8_4.png",
        "alt": "2026江苏绿色低碳低碳建筑国际博览会|南京组团展",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading4",
        "text": "05纳米陶瓷玻璃安全隔热节能膜体验屋"
      },
      {
        "type": "paragraph",
        "text": "基于自主研发无机纳米陶瓷光学材料，利用其“光筛效应”实现光谱靶向调控：在保持15%~75%可见光透过率（可调）的同时，选择性阻隔90%~98%红外线 with 99%以上紫外线，将透过玻璃进入室内的太阳辐射热量降低65%~92%， 从源头上减轻空调制冷负荷，提高室内舒适度，并在冬季减少室内热量散失，提高保温效果.技术特点包括高透光高隔热、无机材料长效耐久（寿命超20年）、A级阻燃 with 防飞溅安全功能.外贴膜、内贴膜适用于既有建筑门窗幕墙节能改造，中间膜用于新建建筑夹层玻璃.产品已在江苏省住建厅、机关事务管理局等全国300余个项目应用，空调综合节能率达30%以上，产品性能经权威机构认证获评国际先进水平。"
      },
      {
        "type": "image",
        "src": "0407_8_5.png",
        "alt": "2026江苏绿色低碳低碳建筑国际博览会|南京组团展",
        "wrapperClassName": "zsfc_pt_img"
      },
      {
        "type": "heading3",
        "text": "目标客户"
      },
      {
        "type": "paragraph",
        "text": "我们诚邀房地产开发商、各类企事业单位、交通枢纽、老旧小区改造项目及高端住宅 with 别墅业主等全场景客户莅临参观.如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。"
      }
    ]
  }
];
